import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  AkaHealthConfig,
  AkaHealthConfigData,
  AkaHealthConfigEntity,
  AkaHealthConfigError,
} from "./akaHealthConfigInterfaces";

const initialState: AkaHealthConfigEntity = {
  current: null,
  isLoading: false,
  error: null,
};

const akaHealthConfigSlice = createSlice({
  name: "akaHealthConfig",
  initialState,
  reducers: {
    akaHealthConfigStart: (
      state,
      _action: PayloadAction<AkaHealthConfigData>,
    ) => {
      state.isLoading = true;
    },

    akaHealthConfigSucceeded: (
      state,
      action: PayloadAction<AkaHealthConfig>,
    ) => {
      state.current = { ...action.payload };
      state.isLoading = false;
      state.error = null;
    },

    operationFailed: (state, action: PayloadAction<AkaHealthConfigError>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  akaHealthConfigStart,
  akaHealthConfigSucceeded,
  operationFailed,
} = akaHealthConfigSlice.actions;

export const akaHealthConfig = akaHealthConfigSlice.reducer;
